import {
  ActionHandler,
  ResetAction
} from 'modules/Cube/domain/cube.domain.types'
import { INITIAL_CUBE_STATE } from 'modules/Cube/domain/cube.constants'

export const reset: ActionHandler<ResetAction> = () => () => INITIAL_CUBE_STATE
